<template>
  <transition name="modal" appear>
    <div class="modal-overlay" @click.self="closeModal">
      <div class="modal-content signup-modal-content">
        <div class="logintop-head">
          <p>Welcome to</p>
          <img src="/images/logo.png" alt="SYNAPSE">
        </div>
        <form class="loginform-synapse signupform-synapse" @submit.prevent="continueToMembership">
          <div class="form-group">
            <label>Username <span>*</span></label>
            <input type="text" v-model="form.username" required autocomplete="username" />
            <span class="field-error" v-if="errors.username">{{ errors.username[0] }}</span>
          </div>

          <div class="form-group">
            <label>Full Name <span>*</span></label>
            <input type="text" v-model="form.fullname" required autocomplete="name" />
            <span class="field-error" v-if="errors.fullname">{{ errors.fullname[0] }}</span>
          </div>

          <div class="form-group">
            <label>Email Address <span>*</span></label>
            <input type="email" v-model="form.email" required autocomplete="email" />
            <span class="field-error" v-if="errors.email">{{ errors.email[0] }}</span>
          </div>

          <div class="form-group password-wrapper">
            <label>Password <span>*</span></label>
            <div class="password-input">
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="form.password"
                required
                autocomplete="new-password"
              />
              <span class="toggle-icon" @click="togglePassword">
                <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </span>
            </div>
            <span class="field-error" v-if="errors.password">{{ errors.password[0] }}</span>
          </div>

          <div class="form-group profile-group">
            <label>Profile Picture <span>*</span></label>
            <div class="file-upload-wrapper" @click="triggerFileInput">
              <input
                type="file"
                ref="fileInput"
                @change="handleFileChange"
                accept="image/*"
                required
              />
              <div class="file-upload-display" v-if="profilePreview">
                <img :src="profilePreview" alt="Profile preview" />
                <button type="button" class="remove-file-btn" @click.stop="removeFile">×</button>
              </div>
              <div class="file-upload-placeholder" v-else>
                <i class="fa fa-cloud-upload"></i>
                <p>Click to upload profile picture</p>
              </div>
            </div>
            <span class="field-error" v-if="errors.profile">{{ errors.profile[0] }}</span>
          </div>

          <div class="form-message" v-if="message">
            <div class="inline-error">{{ message }}</div>
          </div>

          <button type="submit" class="submit-btn" :disabled="isLoading">
            <span v-if="!isLoading">Continue</span>
            <span v-else>Please wait...</span>
            <div class="cardbottom-shadow">
              <img src="/images/cardshadow.png" alt="">
            </div>
          </button>

          <h5>Already have an account? <a href="#" @click.prevent="openLogin">Login</a></h5>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import { lockBodyScrollInline, releaseBodyScrollLock } from '@/views/lib/bodyScrollLock';

export default {
  name: 'SignupModal',
  data() {
    return {
      form: {
        username: '',
        fullname: '',
        email: '',
        password: '',
        profile: null,
      },
      showPassword: false,
      profilePreview: null,
      errors: {},
      message: '',
      isLoading: false,
    };
  },
  mounted() {
    lockBodyScrollInline();
  },
  beforeDestroy() {
    releaseBodyScrollLock();
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    triggerFileInput() {
      if (this.$refs.fileInput) this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;
      this.form.profile = file;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.profilePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeFile() {
      this.form.profile = null;
      this.profilePreview = null;
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    },
    continueToMembership() {
      this.errors = {};
      this.message = '';

      if (!this.form.profile) {
        this.errors = { profile: ['Please upload a profile picture.'] };
        this.message = 'Please fix the errors above.';
        return;
      }

      this.$emit('continue', {
        username: this.form.username,
        fullname: this.form.fullname,
        email: this.form.email,
        password: this.form.password,
        profile: this.form.profile,
      });
    },
    openLogin() {
      releaseBodyScrollLock();
      this.$emit('open-login');
    },
    closeModal() {
      releaseBodyScrollLock();
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
span.toggle-icon {
  font-size: 14px;
  opacity: 0.7;
}

.password-wrapper {
  position: relative;
}

.password-input {
  position: relative;
}

.password-input input {
  width: 100%;
  padding-right: 30px;
}

.toggle-icon {
  position: absolute;
  top: 50%;
  right: 25px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #555;
}

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.4s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .modal-content,
.modal-leave-active .modal-content {
  transition: transform 0.4s ease;
}

.modal-enter-from .modal-content {
  transform: translateY(-40px);
}

.modal-leave-to .modal-content {
  transform: translateY(-40px);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ffffffc7;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
  padding: 20px 12px;
  box-sizing: border-box;
}

.modal-content {
  background: white;
  padding: 30px 40px 0;
  border-radius: 50px;
  position: relative;
  width: 100%;
  max-height: 92vh;
  overflow-y: auto;
  max-width: 380px;
  will-change: transform;
  transform: translateY(0);
  box-shadow: 0 0 23.34px #000000BF;
}

.signup-modal-content .logintop-head {
  padding-bottom: 28px;
}

.form-group {
  margin-bottom: 0.85rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.35rem;
}

.form-group input[type="text"],
.form-group input[type="email"],
.form-group input[type="password"],
.password-input input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #9ded6c75;
  border-radius: 40px;
}

.file-upload-wrapper {
  position: relative;
  width: 140px;
  height: 120px;
  margin: 0 auto;
  cursor: pointer;
}

.file-upload-wrapper input[type="file"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.file-upload-display,
.file-upload-placeholder {
  width: 100%;
  height: 100%;
  border: 2px dashed #c7c8ca;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #E6E7E8;
  transition: border-color 0.3s;
}

.file-upload-wrapper:hover .file-upload-placeholder {
  border-color: #20B14B;
}

.file-upload-display {
  position: relative;
}

.file-upload-display img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-file-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background: #e53935;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.file-upload-placeholder i {
  font-size: 28px;
  color: #9a9b9e;
  margin-bottom: 6px;
}

.file-upload-placeholder p {
  font-size: 11px;
  color: #6D6E71;
  margin: 0;
  padding: 0 8px;
  text-align: center;
  line-height: 1.3;
}

.field-error {
  display: block;
  color: #e53935;
  font-size: 11px;
  margin-top: 4px;
  text-align: center;
}

.form-message {
  margin-bottom: 10px;
}

.inline-error {
  background: #ffebee;
  color: #e53935;
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 12px;
  text-align: center;
}

.submit-btn {
  background-color: #9DED6C;
  color: #231F20;
  padding: 5px 0;
  border: 1px solid #00a14b75;
  border-radius: 35px;
  cursor: pointer;
  width: 111.84px;
  transition: all 0.6s ease;
  font-weight: bold;
  font-size: 14px;
  height: 29.60px;
  position: relative;
  margin: 8px 0 10px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.submit-btn:hover:not(:disabled) {
  background: #20B14B;
  color: #fff;
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.submit-btn .cardbottom-shadow img {
  left: 50%;
  transform: translate(-50%);
  width: 200px;
}

.profile-group {
  margin-bottom: 1rem;
}

@media (max-width: 480px) {
  .modal-content {
    padding: 24px 22px 0;
    border-radius: 32px;
  }
}
</style>
